import { render, staticRenderFns } from "./departmentArchives.vue?vue&type=template&id=a9d27472&"
import script from "./departmentArchives.vue?vue&type=script&lang=js&"
export * from "./departmentArchives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports